import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';

import { Bill } from 'src/app/model/bill.model';

import { Customer } from 'src/app/model/customer.model';

import { ApiService } from 'src/app/services/api.service';

import { ImagepreviewComponent } from '../imagepreview/imagepreview.component';

import { BillDateDialogComponent } from '../../date-change/bill-date-dialog.component';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { MatPaginator } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';

import { MatSnackBar } from '@angular/material/snack-bar';

import { CookieService } from 'ngx-cookie-service';

import {formatDate} from '@angular/common';

import { Role } from 'src/app/model/role';

import { HttpClient } from '@angular/common/http';

import { PaymentsComponent } from '../payments/payments.component';



export interface Payment {

  paymentId: number;

  billNumber: number;

  custId: number;

  paymentDate: string;

  amountReceived: number;

  paymentReceivedPhone: string;

  textMessage: string;

  textMessageBalance: number;

  paymentRemark:string;

}



@Component({

  selector: 'app-billdetails',

  templateUrl: './billdetails.component.html',

  styleUrls: ['./billdetails.component.scss'],

})



export class BilldetailsDialog implements OnInit {

  displayedColumns: string[] = [

    'billNumber',

    'billDate',

    'employeeId',

    'unitsConsumed',

    'billUnitRate',

    'billAmount',

    'billPaidStatus',

    'billProof',

    'action',

    'payments'

  ];





  dataSource = new MatTableDataSource<Bill[]>(null);

  isVisible: boolean = false;

  showNewBill: boolean = false;

  partialAmount: number;

  disablePartialAmount: boolean;

  enableBillEdits: boolean = false;

  finalBillDueAmount: number = 0;

  defaultBillPaidStatus: string;

  adminLogin: boolean = false;

  sysadminLogin: boolean = false;

  adminOrSuperAdminLogin: boolean = false;

  originalDueAmount: number = 0;

  wadarta: number = 0;

  rhore: number = 0;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  cutOffEditable: boolean = false;









  constructor(

    private sanitizer: DomSanitizer,

    public dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data: Customer,

    private apiService: ApiService,

    private cookieService: CookieService,

    private http: HttpClient,

    private _snackBar: MatSnackBar

  ) { 

    this.getBillDetails();

    

  }

  showEditForm: boolean = false;

  allowUpdate: boolean = false;

  billData: Bill;

  originalBillAmount : number=0;

  newBillData: Bill;

  selectedBill: number;

  allBills: Bill[];

  maxBill : number=0;

  btnDisable: boolean = false;

  isAdminOrSuperAdminOrSysAdmin : boolean = false;

  ngOnInit(): void {

   

    this.checkLoginType();

  }

  getBillDetails() {

    this.isVisible = false;

    this.apiService.getBills(this.data).subscribe((data) => {

      this.dataSource = new MatTableDataSource<Bill[]>(data.bills);

      this.allBills = data.bills;

      this.dataSource.paginator = this.paginator;

      this.dataSource.sort = this.sort;

    });

  }

  getMyBillDetails(){

    this.showEditForm = false;

    this.showNewBill = false;

    this.getBillDetails();

   

  }

  createNewBill(customerData: Customer): void{

    this.btnDisable = false;

    this.showNewBill = true;

    this.showEditForm = true;

    this.isVisible = true;

    this.newBillData = new Bill;

    this.newBillData.customerId = customerData.customerId;

    this.newBillData.meterId = customerData.meterId;

    this.newBillData.billUnitRate = customerData.customerUnitRate ;

    this.newBillData.qiyaas = false;

    this.maxBill = this.allBills.reduce((a,b)=>a.billNumber>b.billNumber?a:b).currentReading;

      this.newBillData.previousReading = this.maxBill;

  }



  checkLoginType() {

    const loggedInUser = window.localStorage.getItem('loggedInUser');

    // this.apiService.getEmployeeDetailsById(loggedInUser).subscribe((data) => {

    //   if(data.employeeRole === "superadmin"){

    //     this.adminLogin =true;

    //   }

    //   else{

    //     this.adminLogin =false;

    //   }



    //   if(data.employeeRole === "sysadmin"){

    //     this.sysadminLogin =true;

    //   }

    //   else{

    //     this.sysadminLogin =false;

    //   }

     

    // });



      this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data) => {

          

           let roles = data.roles.map((role : Role)=>role.roleName);

           if(roles.includes("superadmin")){

            this.adminLogin =true;  

           }

    

           if(roles.includes("sysadmin")){

            this.sysadminLogin = true;

           }   

            if(roles.includes("sysadmin") || roles.includes("admin") ||roles.includes("superadmin")){

               this.isAdminOrSuperAdminOrSysAdmin = true;

            }



            if(roles.includes("superadmin") || roles.includes("admin")){

              this.adminOrSuperAdminLogin =true;  

            }



            

        });

  }

  

  calculateBillAmount() {

    const unitRate = this.billData.billUnitRate;

    const unitsConsumed = this.billData.unitsConsumed;

    this.billData.billAmount = unitRate * unitsConsumed;

  }



  computeRh(): void {

    let previousRh = 0; // Initialize the RH for the first bill

  

    this.allBills.forEach((bill, index) => {

      const currentRh = bill.dueAmount - bill.badDebt - bill.discount - (bill.vat || 0);

  

      if (index === 0) {

        bill.rh = currentRh; // First row: only calculate current RH

      } else {

        bill.rh = previousRh + currentRh; // Subsequent rows: add current RH to previous RH

      }

  

      previousRh = bill.rh; // Update the previous RH for the next iteration

    });

  }

  



  editBill(data: Bill,index:number) {

    this.computeRh();

    console.log("Index",index)

    this.allowUpdate= false;

    this.enableBillEdits = false;

    this.isVisible = true;

    //this.finalBillDueAmount = (data.billAmount - (data.billAmount - data.dueAmount)) - data.badDebt - data.discount; //commented

  //  this.wadarta = data.billAmount + (this.data.customerDueAmount - data.dueAmount); //commented

  //this.rhore = this.data.customerDueAmount - data.dueAmount; //commented

    if(index == 0){

      this.rhore = 0;

    }else{

      let bill : Bill = this.allBills[index-1];

      this.rhore =bill.rh;

    }



    this.wadarta = data.billAmount + this.rhore;

    this.finalBillDueAmount = parseFloat(

      (

        this.wadarta - data.billAmount + data.dueAmount - data.badDebt - data.discount - (data.vat || 0)

      ).toFixed(2)

    );



    this.originalDueAmount = data.dueAmount;

    this.originalBillAmount = data.billAmount;

    if(data.billPaidStatus == 'PP'){

      this.partialAmount = data.billAmount - data.dueAmount;

      this.disablePartialAmount = false;

    }else{

      this.partialAmount = 0;

    }

    delete data.billProof;

    this.defaultBillPaidStatus = data.billPaidStatus;

    this.showEditForm = !this.showEditForm;

    if(this.adminLogin && this.defaultBillPaidStatus != 'P'){

      this.enableBillEdits = true;

      this.allowUpdate= true;

    } else if(this.defaultBillPaidStatus == 'PP') {

      this.enableBillEdits = false;

      this.allowUpdate= true;

    }

    this.billData = data;

    this.cutOffEditable = this.isBillDateEditable(data.billDate);

    if(this.sysadminLogin){

      this.enableBillEdits = true;

    }

  }



  billPayments(data: Bill,index:number){

    this.computeRh();

    if(index ==0){

      data.rh=0;

    }else{

      const prevBill = this.allBills[index -1];

      data.rh = prevBill.rh;

    }

  

    const dialogRef = this.dialog.open(PaymentsComponent, {

      width: '100%',

      data: {bill:data,allBills:this.allBills}

    });



    dialogRef.afterClosed().subscribe((result) => {

    });

 

  }



  isBillDateEditable(billDateStr) {

    // Parse the billDate

    const billDate = new Date(billDateStr);



    // Calculate the cutoff date

    const cutoffDate = new Date(billDate.getFullYear(), billDate.getMonth(), 25); // Default to 25th of the bill's month

    if (billDate.getDate() >= 25) {

        // Move to the 25th of the next month

        cutoffDate.setMonth(cutoffDate.getMonth() + 1);

    }



    // Get today's date

    const today = new Date();



    // Check if today's date is before or on the cutoff date

    return today <= cutoffDate;

}





  updateBillDetails() {

     

    if(this.defaultBillPaidStatus == 'P' && this.billData.billPaidStatus == 'P'){

      this.billData.dueAmount = 0;

    }



    const today = new Date();

    const formattedDate = today.toISOString().split('T')[0];

    this.billData.billPaidDate = formattedDate;

    this.billData.partialAmount = this.partialAmount;



     this.apiService.updateBillDetails(this.billData).subscribe((data) => {

      if (data.isSuccess) {

        this.showEditForm = !this.showEditForm;

        this.isVisible = !this.isVisible;

        this.getBillDetails();

      }

    });

  }



  updateDueAmount(){

    //console.log('this.billData.dueAmount=',this.billData.dueAmount);

      let prevPaidAmount = this.originalBillAmount - this.originalDueAmount;

      this.billData.dueAmount = this.billData.billAmount - prevPaidAmount -this.partialAmount; 

    //  this.finalBillDueAmount = (this.billData.billAmount - (this.billData.billAmount - this.billData.dueAmount)) - this.billData.badDebt - this.billData.discount;

    //commented above line

      this.finalBillDueAmount = 

    this.finalBillDueAmount = parseFloat(

          (

          (this.wadarta - this.partialAmount) - this.billData.badDebt - this.billData.discount - (this.billData.vat || 0)

          ).toFixed(2)

        );



    

      // this.wadarta = this.billData.billAmount + (this.data.customerDueAmount - this.billData.dueAmount);

      //this.rhore = this.data.customerDueAmount - this.billData.dueAmount;

  }

  updateBadDebt(){

    //console.log('this.billData.dueAmount=',this.billData.dueAmount);

    //this.finalBillDueAmount = (this.billData.billAmount - (this.billData.billAmount - this.billData.dueAmount)) - this.billData.badDebt - this.billData.discount;



   //commented above line

   this.finalBillDueAmount = (this.wadarta - (this.billData.billAmount - this.billData.dueAmount)) - this.billData.badDebt - this.billData.discount - (this.billData.vat || 0);

    

  }

updateDiscount(){

  //console.log('this.billData.dueAmount=',this.billData.dueAmount);

  //this.finalBillDueAmount = (this.billData.billAmount - (this.billData.billAmount - this.billData.dueAmount)) - this.billData.badDebt - this.billData.discount;

   //commented above line

   this.finalBillDueAmount = (this.wadarta - (this.billData.billAmount - this.billData.dueAmount)) - this.billData.badDebt - this.billData.discount - (this.billData.vat || 0);

    



}

updateVat(){

   this.finalBillDueAmount = (this.wadarta - (this.billData.billAmount - this.billData.dueAmount)) - this.billData.badDebt - this.billData.discount - (this.billData.vat || 0);

}

updateBillAmount(){

  this.billData.dueAmount = this.billData.billAmount -  this.partialAmount;

  

}

onQiyaasChange() {

  if (!this.newBillData.qiyaas) {

    return;

  }

  this.apiService.getQiyaasEstimate(this.newBillData.customerId).subscribe(

    (data) => {

      this.newBillData.qiyaasAmount = data.qiyaasAmount;

      this.newBillData.qiyaasReading = data.qiyaasReading;

      this.newBillData.previousReading = data.previousReading;

      this.newBillData.currentReading = data.previousReading;

      this.setBillAmount();

    },

    (error) => {

      this.newBillData.qiyaas = false;

      alert('No Bills for last three Months');

    }

  );

}



saveBillDetails(){

  this.btnDisable = true;

  const loggedInUser = window.localStorage.getItem('loggedInUser');

  this.newBillData.billPaidStatus = 'NP';

  this.newBillData.dueAmount = this.newBillData.billAmount;

  this.newBillData.billDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  this.newBillData.employeeId = parseInt(loggedInUser);

  this.apiService.saveBillDetails(this.newBillData).subscribe((data) => {

      if (data && data.billNumber) {

        this._snackBar.open('Bill is Created', 'Close', { duration: 3000 });

        this.showNewBill = false;

        this.showEditForm = false;

        this.isVisible = false;

        this.getBillDetails();

      } else {

        this._snackBar.open('Error: Bill not created', 'Close', { duration: 3000 });

        this.btnDisable = false;

      }

    }, (error) => {

      this._snackBar.open('Error: Bill not created', 'Close', { duration: 3000 });

      this.btnDisable = false;

    });

}

setBillAmount(){

  if(this.newBillData.qiyaas){

    this.newBillData.billAmount = this.newBillData.qiyaasAmount;

    if(this.newBillData.qiyaasReading && this.newBillData.previousReading){

      this.newBillData.unitsConsumed = this.newBillData.qiyaasReading - this.newBillData.previousReading;

    }

  }

  else if(this.newBillData.currentReading!=0){

    this.newBillData.unitsConsumed = (this.newBillData.currentReading - this.newBillData.previousReading );

    this.newBillData.billAmount = (this.newBillData.currentReading - this.newBillData.previousReading ) * this.newBillData.billUnitRate;

  }

  else{

    this.newBillData.unitsConsumed = null;

    this.newBillData.billAmount = null; 

  }

}

deleteBill(): void {

  this.apiService.deleteBillNumber(this.selectedBill)

    .subscribe(data => {

      if (data.isSuccess) {

        this.showEditForm = !this.showEditForm;

        this.isVisible = !this.isVisible;

        this.getBillDetails();

      }

    });

}

  openBillDateChange(): void {
    if (!this.sysadminLogin || !this.billData) {
      return;
    }
    const dialogRef = this.dialog.open(BillDateDialogComponent, {
      width: '420px',
      data: { bill: this.billData },
    });
    dialogRef.afterClosed().subscribe((newDate: string) => {
      if (newDate) {
        this.billData.billDate = newDate;
        this.getBillDetails();
      }
    });
  }

  showMeterReading(billData: Bill): void {

    const dialogRef = this.dialog.open(ImagepreviewComponent, {

      width: '300px',

      data: billData,

    });



    dialogRef.afterClosed().subscribe((result) => {

    });

  }

}

